// extracted by mini-css-extract-plugin
export default {"otpContainer":"styles_otpContainer__5neJs","input":"styles_input__SRUxI","otpBox":"styles_otpBox__XwNRU"};